import { render, staticRenderFns } from "./TheMyFavoritesEditListPanel.vue?vue&type=template&id=b1323300&scoped=true"
import script from "./TheMyFavoritesEditListPanel.vue?vue&type=script&lang=js"
export * from "./TheMyFavoritesEditListPanel.vue?vue&type=script&lang=js"
import style0 from "./TheMyFavoritesEditListPanel.vue?vue&type=style&index=0&id=b1323300&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1323300",
  null
  
)

export default component.exports